import { render, staticRenderFns } from "./TagEdit.vue?vue&type=template&id=5d8e001f&scoped=true"
import script from "./TagEdit.vue?vue&type=script&lang=js"
export * from "./TagEdit.vue?vue&type=script&lang=js"
import style0 from "./TagEdit.vue?vue&type=style&index=0&id=5d8e001f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8e001f",
  null
  
)

export default component.exports